import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss',
})
export class ContextMenuComponent implements OnChanges {
  @Input() tooltip: string = '';
  @Input() options: any[] = [];
  @Input() labelKey: string = '';

  @Input() boxSize: string = '200';
  @Input() class!: string;

  @Output() onSelect = new EventEmitter<any[]>();

  @ContentChild('extraContent', { static: false })
  extraContentTemplate!: TemplateRef<any>;

  selected: any[] = [];
  filteredOptions: any[] = [];
  searchTerm: string = '';
  showDropdown: boolean = false;
  foundCount: number | null = 0;

  constructor(private eRef: ElementRef) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && changes['options'].currentValue) {
      this.options = changes['options'].currentValue;
    }
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  selectOption(option: any) {
    this.onSelect.emit(option);
    this.showDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }
}
